import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["label", "isNumber", "style"];
import React from 'react';
import { TouchableHighlight, Text, View } from 'react-native';
var PageButton = function PageButton(_ref) {
  var label = _ref.label,
    isNumber = _ref.isNumber,
    style = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded);
  var color = style.color;
  delete style.color;
  return /*#__PURE__*/React.createElement(TouchableHighlight, Object.assign({
    style: style
  }, rest), /*#__PURE__*/React.createElement(Text, {
    style: {
      color: color
    }
  }, label));
};
var Pagination = function Pagination(_ref2) {
  var page = _ref2.page,
    numberOfPages = _ref2.numberOfPages,
    onPageChange = _ref2.onPageChange,
    label = _ref2.label,
    styles = _ref2.styles;
  var pageProps = function pageProps(forPage, isNumber) {
    var isCurrent = 1 === numberOfPages || forPage === page;
    var buttonStyle = _objectSpread({
      paddingLeft: 6,
      paddingRight: 6,
      paddingTop: 2,
      paddingBottom: 2
    }, styles === null || styles === void 0 ? void 0 : styles.button);
    var currentButtonStyle = _objectSpread(_objectSpread({}, buttonStyle), {}, {
      color: 'gray'
    }, styles === null || styles === void 0 ? void 0 : styles.currentButton);
    var currentNumberButtonStyle = _objectSpread(_objectSpread({}, buttonStyle), {}, {
      borderWidth: 1,
      borderColor: 'black',
      borderRadius: 4
    }, styles === null || styles === void 0 ? void 0 : styles.currentNumberButton);
    var style = buttonStyle;
    if (isCurrent) {
      if (isNumber) {
        style = currentNumberButtonStyle;
      } else {
        style = currentButtonStyle;
      }
    }
    return {
      style: style,
      disabled: isCurrent,
      onPress: function onPress() {
        return onPageChange(forPage);
      }
    };
  };
  var style = _objectSpread({
    flexDirection: 'row',
    justifyContent: 'flex-end',
    margin: 10
  }, styles === null || styles === void 0 ? void 0 : styles.container);
  var labelStyle = _objectSpread({
    marginRight: 30
  }, styles === null || styles === void 0 ? void 0 : styles.label);
  var maxPage = numberOfPages - 1;
  var startPage = Math.min(Math.max(0, page - 2), maxPage - 4);
  var showPages = [0, 1, 2, 3, 4].map(function (i) {
    return i + startPage;
  });
  showPages = showPages.filter(function (i) {
    return i <= maxPage && i >= 0;
  });
  return /*#__PURE__*/React.createElement(View, {
    style: style
  }, label && /*#__PURE__*/React.createElement(Text, {
    style: labelStyle
  }, label), /*#__PURE__*/React.createElement(PageButton, Object.assign({
    label: "First"
  }, pageProps(0))), /*#__PURE__*/React.createElement(PageButton, Object.assign({
    label: "Previous"
  }, pageProps(Math.max(0, page - 1)))), showPages.map(function (i) {
    return /*#__PURE__*/React.createElement(PageButton, Object.assign({
      key: i,
      label: i + 1
    }, pageProps(i, true)));
  }), /*#__PURE__*/React.createElement(PageButton, Object.assign({
    label: "Next"
  }, pageProps(Math.min(maxPage, page + 1)))), /*#__PURE__*/React.createElement(PageButton, Object.assign({
    label: "Last"
  }, pageProps(maxPage))));
};
export default Pagination;